import { useState } from "react";
import { MysteryBoxGame } from "@/components/mystery-box";
import { PublicMobileVerification } from "@/components/gamepoint/PublicMobileVerification";

export default function PublicMysteryBox() {
  const [isVerified, setIsVerified] = useState(false);

  return (
    <div className="scrollbar-casino h-screen overflow-x-hidden overflow-y-auto overscroll-y-contain bg-gradient-to-b from-[#030712] via-[#0f172a] to-[#1e1b4b] px-4 py-10 pb-16">
      <div className="mx-auto w-full max-w-4xl space-y-8 pb-8">
        <div className="space-y-3 text-center">
          <p className="text-xs font-semibold uppercase tracking-[0.35em] text-amber-400/80">
            Game Point
          </p>
          <h1 className="text-3xl font-extrabold tracking-tight text-white drop-shadow-sm md:text-4xl">
            Pick a Box.{" "}
            <span className="bg-gradient-to-r from-amber-300 via-purple-400 to-blue-400 bg-clip-text text-transparent">
              Reveal Your Reward.
            </span>
          </h1>
          <p className="mx-auto max-w-xl text-sm text-purple-200/70 md:text-base">
            Verify your mobile number once, then choose a mystery box to unlock
            bonus points.
          </p>
        </div>

        <PublicMobileVerification
          theme="mystery"
          onVerifiedChange={setIsVerified}
        />

        {isVerified ? (
          <MysteryBoxGame className="mx-auto w-full" dailyAttemptsRemaining={3} />
        ) : (
          <div className="mx-auto flex max-w-2xl flex-col items-center justify-center rounded-2xl border border-dashed border-purple-500/25 bg-black/20 px-6 py-16 text-center backdrop-blur-sm">
            <p className="text-4xl mb-3">📦</p>
            <p className="text-sm text-blue-200/60">
              Complete mobile verification above to unlock the mystery boxes.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
